import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../../../commons/enums/status-enum";
import { manageFootballTeamService } from "../../../../../../../commons";

interface ISubTeamPlayerRemoveState {
  manageSubTeamPlayerRemoveStatus: StatusEnum;
}

interface IPlayerRemoveInfo {
  endAt: string;
}

const initialState: ISubTeamPlayerRemoveState = {
  manageSubTeamPlayerRemoveStatus: StatusEnum.Idle,
};

export interface IManageSubTeamPlayerRemoveOption {
  teamId: number;
  subTeamId: number;
  playerId: number;
  playerInfo: IPlayerRemoveInfo;
}

export const subTeamPlayerRemove = createAsyncThunk(
  "manage/subTeamPlayerRemove",
  async (options: IManageSubTeamPlayerRemoveOption, thunkAPI) => {
    try {
      const subTeamPlayerRemoveResponse = await manageFootballTeamService.removeSubTeamPlayer(
        options.teamId,
        options.subTeamId,
        options.playerId,
        options.playerInfo.endAt
      );
      return subTeamPlayerRemoveResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const subTeamPlayerRemoveSlice = createSlice({
  name: "subTeamPlayerRemove",
  initialState: initialState,
  reducers: {
    cleanUpSubTeamPlayerRemove(state) {
      state.manageSubTeamPlayerRemoveStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(subTeamPlayerRemove.pending, (state) => {
        state.manageSubTeamPlayerRemoveStatus = StatusEnum.Loading;
      })
      .addCase(subTeamPlayerRemove.fulfilled, (state, action) => {
        state.manageSubTeamPlayerRemoveStatus = StatusEnum.Succeeded;
      })
      .addCase(subTeamPlayerRemove.rejected, (state) => {
        state.manageSubTeamPlayerRemoveStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpSubTeamPlayerRemove } = subTeamPlayerRemoveSlice.actions;
export default subTeamPlayerRemoveSlice.reducer;
